import { lazyGovern } from './lazyFunctions';

export function governOrEvent<T>(
    name: string,
    task: () => Promise<T>,
    eventCb: Promise<void>
): Promise<T> {
    return new Promise<T>((res, rej) => {
        let taskFinished = false;
        function callTask() {
            if (!taskFinished) {
                taskFinished = true;
                task().then(res).catch(rej);
            }
        }

        // this is a race between the govern task and the event cb.
        lazyGovern.importAndExecute({ task: callTask, name });
        eventCb.then(callTask);
    });
}
